jQuery(document).ready(function($) {
    if (screen.width < 1030) {
        initAccordionSlider();

        function initAccordionSlider() {
            const slider = $('.accordion-slider');
            slider.slick({
                adaptiveHeight: false,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
                swipe: true,
                swipeToSlide: true,
                cssEase: 'cubic-bezier(0.4, 0.2, 0.4, 1)',
                prevArrow: $('.mobile_navigation .bi-arrow-left-short'),
                nextArrow: $('.mobile_navigation .bi-arrow-right-short'),
            });
            $(window).on('resize orientationchange', function() {
                slider.slick('refresh')
            })
        }
    } else {
        $('.accordion-slider').on('click', '.accordion-slider__card', function (e) {
            let card = $(this).closest('.accordion-slider__card'),
                cards = $('.accordion-slider').find('.accordion-slider__card');

            if (!card.hasClass('active')) {
                cards.removeClass('active');
                card.addClass('active');
            } else {
                if ( $(e.target).hasClass('bi-arrow-left-short') ) {
                    cards.removeClass('active');
                    $(this).closest('.accordion-slider__card').prev().addClass('active');
                } else if ( $(e.target).hasClass('bi-arrow-right-short') ) {
                    cards.removeClass('active');
                    $(this).closest('.accordion-slider__card').next().addClass('active');
                }
            }
        });
    }
});